/**
 * Product page  - price on button
 * https://www.wrike.com/open.htm?id=684781451
 */
( $ => {

  const __recalc_price = function(){
    setTimeout( function(){
      let quantity = $( '.product-quantity input.qty' ).val() || 1,
          discount = (
              $( '.wcsatt-options-prompt-radios input:checked' ).val() === 'yes'
                  ? 1 - Number( $( '.wcsatt-options-prompt-radios .wcsatt-sub-discount' ).html().replace( '%', '' ) )/100
                  : 1
          ),
          bdi = $( '.single_add_to_cart_button .price bdi' ),
          variation = $( '.variations-options .value > select' ).eq(0).val(),
          var_data = $( 'form.variations_form' ).data( 'product_variations' ),
          price = 0,
          new_price = 0;

      for( const v of var_data )
        if(
            v.attributes[ 'attribute_pa_choose-package-size' ] === variation ||
            v.attributes[ 'attribute_pa_size' ] === variation ||
            v.attributes[ 'attribute_pa_groesse-waehlen' ] === variation ||
            v.attributes[ 'attribute_pa_groesse' ] === variation
        ){
          price = v.display_price;
          break;
        }
      new_price = price * quantity * discount;
      bdi.contents().first().replaceWith( new_price.toFixed(2).replace( '.', ',' ) + ' ' );
    }, 1 );
  }

  const __assign = function (){
    $(
        '.product-quantity input.qty, ' +
        '#pa_choose-package-size, ' +
        '#pa_size, ' +
        '.wcsatt-options-prompt-action-input' + '.variations-options .value > select'
    ).on('change', __recalc_price);
    $( '.woocommerce-variation.single_variation' ).on( 'DOMSubtreeModified', () => {
      $( '.wcsatt-options-prompt-action-input' ).on('change', __recalc_price);
    });
    __recalc_price();
  }

  $( document ).ready( () => {
    if( $( 'form.variations_form' ).length ) // only if we are on single product page
      setTimeout( __assign, 1000 )
  } );

} )( jQuery.noConflict() );



(function($) {
    const __init = () => {
      const element = $('.wcsatt-options-product-dropdown')[0];
      const select = $('.wcsatt-options-product-dropdown');
      const simpleSubscription = $('.simple-product-subc-options');
      const simpleSubscriptions = $('.simple-product-subc-options li');
      const singleAddToCartButton = $('.single_add_to_cart_button');

      if (select.length > 0) {
        const choices = new Choices(element, {
          searchEnabled: false,
          itemSelectText: '',
          shouldSort: false,
          placeholder: false,
          position: 'bottom',
        });

        // if (simpleSubscription.length > 0) {
        //   select.on('change', function (event) {
        //     simpleSubscriptions.each(function (elem) {
        //       let _this = $(this);
        //       if (_this.attr('data-value') === $(event)[0].detail.value) {
        //         singleAddToCartButton.find('.price').remove();
        //         let clone = _this.find('.price').clone();
        //         singleAddToCartButton.append(clone)
        //       }
        //     })
        //   })
        // }
      }

      // Re-init choices dropdown after variation change

      // Select the node that will be observed for mutations
      const targetNodes = document.querySelectorAll('.woocommerce-variation.single_variation');

      // Options for the observer (which mutations to observe)
      const config = {childList: true};

      // Callback function to execute when mutations are observed
      const callback = function (mutationsList, observer) {
        for (const mutation of mutationsList) {

          const selectElement = mutation.target.querySelector('.wcsatt-options-product-dropdown');
          if (selectElement) {
            const choices = new Choices(selectElement, {
              searchEnabled: false,
              itemSelectText: '',
              shouldSort: false,
              placeholder: false,
              position: 'bottom'
            });
          }
        }
      };

      // Create an observer instance linked to the callback function
      for (const targetNode of targetNodes) {
        const observer = new MutationObserver(callback);
        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
      }

      /*
      * Add custom radio options for single product page
       */

      const productOptionLabel = $( '.product-option--label' ),
        selectSize = $( '.variations-options .value > select' );

      productOptionLabel.each( function ( i, item ) {
        let _this = $( item ),
          labelOption = _this.data( 'option' );

        if ( labelOption === selectSize.val() ) {
          _this.addClass( 'active' );
        }

        _this.on( 'click', function () {
          _this.addClass( 'active' );
          _this.siblings( 'label' ).removeClass( 'active' );
          let option = selectSize.find( 'option' );
          option.each( function ( i, el ) {
            let item = $( el );
            if ( item.attr( 'value' ) === labelOption ) {
              selectSize.val( item.attr( 'value' ) );
              selectSize.trigger( 'change' );
              console.log(selectSize.val());
            }
          } );
        } );
      } );


      /**
       * Product quantity and custom quantity for simple product
       * https://www.wrike.com/open.htm?id=692519854
       */

      const productQuantityButton = $('.product-quantity--button');
      const productQuantityInput = $('.cart input[type="number"]');
      const addToCartBtn = $('.single_add_to_cart_button');
      const subscriptionWrapper = $('.wcsatt-options-wrapper');
      const simpleProduct = $('.product.product-type-simple');

      const findAndAddToCartPrice = ( curPriceText, nPrice, curPrice, elem, val ) => {
        if ( !Number.isInteger( +curPriceText ) ) {
          curPrice.text( nPrice.toFixed( 2 ).toString().replace( '.', ',' ) );

          if ( elem.data( 'value' ) === 'one-time-option' ) {
            if ( $( '.wcsatt-options-prompt-action-input' ).eq( 0 ).is( ':checked' ) ) {
              addToCartBtn.find( '.price-count' ).text( nPrice.toFixed( 2 ).toString().replace( '.', ',' ) );
            }
          }

          if ( val === elem.data( 'value' ) ) {
            if ( $( '.wcsatt-options-prompt-action-input' ).eq( 1 ).is( ':checked' ) ) {
              addToCartBtn.find( '.price-count' ).text( nPrice.toFixed( 2 ).toString().replace( '.', ',' ) );
            }
          }
        } else {
          curPrice.text( nPrice );
          if ( elem.data( 'value' ) === 'one-time-option' ) {
            if ( $( '.wcsatt-options-prompt-action-input' ).eq( 0 ).is( ':checked' ) ) {
              addToCartBtn.find( '.price-count' ).text( nPrice );
            }
          }

          if ( val === elem.data( 'value' ) ) {
            if ( $( '.wcsatt-options-prompt-action-input' ).eq( 1 ).is( ':checked' ) ) {
              addToCartBtn.find( '.price-count' ).text( nPrice.toString() );
            }
          }
        }
      };

      const checkIfOneQuantity = ( el, pr, vl ) => {
        if ( $( '.wcsatt-options-prompt-action-input' ).eq( 0 ).is( ':checked' ) ) {
          addToCartBtn.find( '.price-count' ).text( pr );
        }
        if ( $( '.wcsatt-options-prompt-action-input' ).eq( 1 ).is( ':checked' ) ) {
          if ( vl === el.data( 'value' ) ) {
            addToCartBtn.find( '.price-count' ).text( el.data( 'price' ) );
          }
        }
      };

      const changeQty = ( element, qStatus, quantity, price ) => {
        let currentPrice = element.find( '.price-count' );
        let currentPriceText = element.find( '.price-count' ).text();
        let value = $( '.wcsatt-options-product-wrapper .choices__item' ).attr( 'data-value' );
        let newPrice;

        if ( qStatus === '-' ) {
			price = price + '';

			if ( quantity === 1 ) {
            currentPrice.text( price );
            checkIfOneQuantity( element, price, value );
          } else {
            if ( !Number.isInteger( +currentPriceText ) ) {
              newPrice = +( currentPriceText.indexOf(',') > -1 ? currentPriceText.replace( ',', '.' ) : currentPriceText ) - +( price.indexOf(',') > -1 ? price.replace( ',', '.' ) : price );
            } else {
              newPrice = +currentPriceText - +price;
            }
            findAndAddToCartPrice( currentPriceText, newPrice, currentPrice, element, value );
          }
        }

        if ( qStatus === '+' ) {
			price = price + '';

			if ( quantity === 1 ) {
            currentPrice.text( price );
            checkIfOneQuantity( element, price, value );
          } else {
            if ( !Number.isInteger( +currentPriceText ) ) {
              newPrice = +( currentPriceText.indexOf(',') > -1 ? currentPriceText.replace( ',', '.' ) : currentPriceText ) + +( price.toString().indexOf(',') > -1 ? price.toString().replace( ',', '.' ) : price );
            } else {
              newPrice = +currentPriceText + +price;
            }
            findAndAddToCartPrice( currentPriceText, newPrice, currentPrice, element, value );
          }
        }
      };

      const findPrice = ( elem, qty, qtyStatus ) => {
        elem.each( function ( item ) {
          let _item = $( this ),
            itemPrice = _item.data( 'price' );
          changeQty( _item, qtyStatus, qty, itemPrice );
        } );
      };

      const setDataPriceIfNoSubscriptions = () => {
        let price = $('.product-type-simple .price bdi, .product-type-simple .price ins bdi').clone();
        price[0].childNodes.forEach(function (item) {
          if (item.nodeName === '#text') {
            $('.product-type-simple .price').attr('data-price', item.textContent.trim());
          }

          if (item.className === 'woocommerce-Price-currencySymbol') {
            $('.product-type-simple .price').attr('data-currency', item.textContent.trim())
          }
        })
      }

      const qtyChangeIfNoSubscriptions = (qtyStatus, quantity) => {
        let productPriceData = $('.product-type-simple .price').data('price');
        let thisPrice = addToCartBtn.find('.price-count').text();
        let newPrice;
        if (qtyStatus === "+") {
          if (quantity === 1) {
            addToCartBtn.find('.price-count').text(productPriceData)
          }else {
            newPrice = +thisPrice.replace(',', '.') + +productPriceData.replace(',', '.');
            console.log(newPrice);
            if (!Number.isInteger( +newPrice )) {
              addToCartBtn.find('.price-count').text(newPrice);
            }else {
              addToCartBtn.find('.price-count').text(newPrice)
            }
          }
        }

        if (qtyStatus === '-') {
          if (quantity === 1) {
            addToCartBtn.find('.price-count').text(productPriceData)
          }else {
            newPrice = +thisPrice - +productPriceData.replace(',', '.');
            if (!Number.isInteger( +newPrice )) {
              addToCartBtn.find('.price-count').text(newPrice.fixed(2));
            }else {
              addToCartBtn.find('.price-count').text(newPrice.toString())
            }
          }
        }
      }

      if ($('.product-type-simple').length > 0) {
        setDataPriceIfNoSubscriptions();
      }

      const handleQtyClick = (event) => {
        const _this = $(event.currentTarget),
          _subscriptionOptions = $('.simple-product-subc-options li'),
          _inputElement = _this.siblings('.quantity').children('.qty'),
          _minValue = parseInt(_inputElement.attr('min')),
          _maxValue = parseInt(_inputElement.attr('max')),
          _stepValue = parseInt(_inputElement.attr('step')),
          _qty = parseInt(_inputElement.val());
        let _newQty;

        if (_this.hasClass('product-quantity--minus')) {
          _newQty = _qty - _stepValue;
          if (_newQty >= _minValue) {
            _inputElement.attr('value', _newQty).val(_newQty).trigger('change');
            if ( subscriptionWrapper.length > 0 && simpleProduct.length > 0 ) {
              findPrice(_subscriptionOptions, _newQty, '-');
            }

            if ( subscriptionWrapper.length === 0 && simpleProduct.length > 0 ){
              qtyChangeIfNoSubscriptions('-', _newQty);
            }
          }

        } else if (_this.hasClass('product-quantity--plus')) {
          _newQty = _qty + _stepValue;
          if (_newQty <= _maxValue) {
            _inputElement.attr('value', _newQty).val(_newQty).trigger('change');
            if ( subscriptionWrapper.length > 0 && simpleProduct.length > 0 ) {
              findPrice( _subscriptionOptions, _newQty, '+' );
            }
            if ( subscriptionWrapper.length === 0 && simpleProduct.length > 0 ){
              qtyChangeIfNoSubscriptions('+', _newQty);
            }
          }
        } else {
          return false;
        }
      }

      productQuantityButton.on('click', function (e) {
        handleQtyClick(e);
      } );

      productQuantityInput.attr('readonly', 'readonly');
      productQuantityInput.val(1);

      /**
       * Price in add to cart button
       * @type {MutationObserver}
       */
      let variation = document.querySelector( '.woocommerce-variation.single_variation' );
      let woocommerceVariationPrice = $( '.woocommerce-variation-price > .price' );

      if ( !localStorage.getItem( 'option-no' ) && !localStorage.getItem( 'option-yes' ) ) {
        localStorage.setItem( 'option-yes', 'true' );
        if (woocommerceVariationPrice.length === 0) {
          setTimeout(function () {
            $('.wcsatt-options-product-wrapper').show();
            $('.choices').show();
          }, 600)
        }
      }

      let button = $( '.single_add_to_cart_button' );
      let buttonText = button.text();

      const subscriptionChange = () => {
        const radio = $( '.wcsatt-options-prompt-label' );
        const radioInput = $( '.wcsatt-options-prompt-action-input' );
        let woocommerceVariationPrice = $( '.woocommerce-variation-price > .price' );
        let clone;

        console.log(woocommerceVariationPrice.text());

        if (woocommerceVariationPrice.length > 0) {
          clone = woocommerceVariationPrice.clone()
          button.find( '.price' ).remove();
          clone.appendTo( button );
          console.log(clone.text());
        }else {
          clone = $('.simple-product-add-to-cart-block > .price').clone();
          button.append(clone)
        }

        radioInput.each( function ( i, item ) {

          let _this = $( item );

          _this.on('change', function () {
            if (_this.val() === 'yes') {
              $('.choices').show();
            }else {
              $('.choices').hide();
            }
          })

          if ( localStorage.getItem( 'option-no' ) && _this.val() === 'no' ) {
            _this.parents( '.wcsatt-options-prompt-label' ).addClass( 'active' );
            _this.parents( '.wcsatt-options-prompt-radio' ).siblings( '.wcsatt-options-prompt-radio' ).find( '.wcsatt-options-prompt-action-input' ).removeAttr('checked');
            _this.attr('checked', 'checked');
            _this.trigger('change');
            if (woocommerceVariationPrice.length > 0) {
              clone.appendTo( button );
            }
          } else if ( localStorage.getItem( 'option-yes' ) && _this.val() === 'yes' ) {
            _this.parents( '.wcsatt-options-prompt-label' ).addClass( 'active' );
            _this.parents( '.wcsatt-options-prompt-radio' ).siblings( '.wcsatt-options-prompt-radio' ).find( '.wcsatt-options-prompt-action-input' ).removeAttr('checked');
            _this.attr('checked', 'checked');
            _this.trigger('change');
            if (woocommerceVariationPrice.length === 0) {
              setTimeout(function () {
                $('.wcsatt-options-product-wrapper').show();
                $('.choices').show();
              }, 600)

            }
          }
        } );

        radio.each( function ( i, item ) {
          let _this = $( item );

          _this.off( 'click' ).on( 'click', function ( e ) {
            _this.parent( '.wcsatt-options-prompt-radio' ).siblings( '.wcsatt-options-prompt-radio' ).find( '.wcsatt-options-prompt-label' ).removeClass( 'active' );
            _this.addClass( 'active' );
            _this.find( '.wcsatt-options-prompt-action-input' ).attr( 'checked', 'checked' ).trigger( 'change' );
            localStorage.setItem( 'option-' + _this.find( '.wcsatt-options-prompt-action-input' ).val(), 'true' );

            if ( _this.find( '.wcsatt-options-prompt-action-input' ).val() === 'yes' ) {
              localStorage.removeItem( 'option-no' );
              if (woocommerceVariationPrice.length === 0) {
                button.text(buttonText);
                clone.appendTo( button );
              }

            } else {
              localStorage.removeItem( 'option-yes' );
              if (woocommerceVariationPrice.length === 0) {
                button.text(buttonText);
                clone.appendTo( button );
              }
            }
            _this.parent( '.wcsatt-options-prompt-radio' ).siblings( '.wcsatt-options-prompt-radio' ).find( '.wcsatt-options-prompt-action-input' ).removeAttr( 'checked' );

            if (woocommerceVariationPrice.length > 0) {
              let woocommerceVariationPrice = $( '.woocommerce-variation-price > .price' );
              let clone;
              clone = woocommerceVariationPrice.clone()
              button.find( '.price' ).remove();
              clone.appendTo( button );
            }

          } );

        } );
      }

      let newObserver = new MutationObserver( ( mutations ) => {
        mutations.forEach( function ( mutation ) {

          let newNodes = mutation.addedNodes;

          if ( newNodes.length > 0 && newNodes[ 3 ].className === 'woocommerce-variation-price' ) {
            subscriptionChange();
          }
        } );
      } );

      let configNew = {
        childList: true
      };

      // Pass in the target node, as well as the observer options
      if (!$('.product').hasClass('product-type-simple')) {
        newObserver.observe( variation, configNew );
      }else {

        /**
         * change radio for single product
         * @type {*|jQuery|HTMLElement}
         */
        const input = $('.wcsatt-options-prompt-action-input');
        const simpleSubscriptions = $('.simple-product-subc-options li');
        const wcsattOptionsWrapper = $('.wcsatt-options-wrapper');

        if (wcsattOptionsWrapper.length > 0) {
          input.each(function (elem) {
            let _this = $(this);
            localStorage.removeItem('option-no');
            localStorage.removeItem('option-yes');

            _this.on('change', function (e) {
              console.log('change');
              let eventTarget = $(e.currentTarget);
              let clone;

              if (eventTarget[0].defaultValue === 'yes') {
                eventTarget.parents('.wcsatt-options-prompt-label').addClass('active');
                eventTarget.parents('.wcsatt-options-prompt-radio').siblings('.wcsatt-options-prompt-radio').find('.wcsatt-options-prompt-label').removeClass('active');
                let value = $('.wcsatt-options-product-wrapper .choices__item').attr('data-value');
                wcsattOptionsWrapper.addClass('subscription');
                wcsattOptionsWrapper.removeClass('one-time');
                simpleSubscriptions.each(function (item) {
                  let _item = $(this);
                  if (_item.attr('data-value') === value ) {
                    setTimeout(function () {
                      clone = _item.find('.price').clone();
                      button.find('.price').remove();
                      button.append(clone)
                    }, 10)
                  }
                })
              } else {
                eventTarget.parents('.wcsatt-options-prompt-label').addClass('active');
                eventTarget.parents('.wcsatt-options-prompt-radio').siblings('.wcsatt-options-prompt-radio').find('.wcsatt-options-prompt-label').removeClass('active');
                wcsattOptionsWrapper.removeClass('subscription');
                wcsattOptionsWrapper.addClass('one-time');

                setTimeout(function () {
                  $('.wcsatt-options-product-wrapper').fadeOut(400);
                  clone = simpleSubscriptions.eq(0).find('.price').clone();
                  button.append(clone)
                }, 10)

              }
            })

            if (_this[0].defaultValue === 'yes') {
              _this.parents('.wcsatt-options-prompt-label').addClass('active');
            }
          })
        }else {
          let priceCount = $('.product-type-simple .price').data('price');
          let priceCurrency = $('.product-type-simple .price').data('currency');
          let priceHtml = `<p class="price"><span class="price-count">${priceCount}</span> <span class="price-currency">${priceCurrency}</span></p>`;

          // console.dir( price );
          button.append(priceHtml);
        }


      }


      /**
       * Accordion for single product
       */

      const tabItem = $( '.ingredients-tab--title' );
      const tabContentItem = $( '.ingredients-content--item' );
      const tab = $( '.ingredients-tab' );
      const ingredientsButton = $( '.ingredients-button' );
      const ingredientsCloseButton = $( '.ingredients-button--close' );
      const ingredientsButtonWrapper = $( '.ingredients-buttons--wrapper' );
      const ingredientsDogImage = $( '.ingredients-dog' );
      const ingredientsWrapper = $( '.ingredients-wrapper' );

      const findContent = ( eachElement, dataTitle, elementAround ) => {
        eachElement.each( function ( i, item ) {
          let _this = $( item ),
            thisDataTitle = _this.data( 'title' );
          if ( dataTitle === thisDataTitle ) {
            _this.addClass( 'active' );
            _this.siblings( elementAround ).removeClass( 'active' );
          }
        } );
      };

      ingredientsCloseButton.on( 'click', function () {
        ingredientsCloseButton.addClass( 'hid' );
        ingredientsButtonWrapper.removeClass( 'hid' );
        tab.addClass( 'hid' );
        tab.hide();
        ingredientsDogImage.css( 'opacity', '1' );
        ingredientsWrapper.removeClass( 'active' );
      } );

      ingredientsButton.on( 'click', function ( e ) {
        let target = $( e.currentTarget ),
          dataTitle = target.data( 'title' );

        tab.removeClass( 'hid' );
        tab.fadeIn( 200 );
        ingredientsCloseButton.removeClass( 'hid' );
        ingredientsButtonWrapper.addClass( 'hid' );
        ingredientsDogImage.css( 'opacity', '0' );
        ingredientsWrapper.addClass( 'active' );

        findContent( tabContentItem, dataTitle, '.ingredients-content--item' );
        findContent( tabItem, dataTitle, '.ingredients-tab--title' );
      } );

      tabItem.on( 'click', function ( e ) {
        let target = $( e.currentTarget ),
          dataTitle = target.data( 'title' );

        if ( !target.hasClass( 'active' ) ) {

          target.siblings( '.ingredients-tab--title' ).removeClass( 'active' );
          target.addClass( 'active' );

          findContent( tabContentItem, dataTitle, '.ingredients-content--item' );

        }
      } );

      const countReview = $( '.comment-text .star-rating strong.rating' );
      const review = $( '.comment-text .star-rating' );
      const reviewItem = $( '.review-list .review' );
      const reviewList = $( '.review-list' );
      const buttonTextMore = reviewList.data( 'more' );
      const buttonTextLess = reviewList.data( 'less' );
      const showMoreReviewsButton = $( `<a href="#" class="review-more button button--medium button--primary">${ buttonTextMore }</a>` );

      review.wrap( '<div class=\'star-wrap\'></div>' );

      countReview.each( function ( i, item ) {
        let _this = $( item ),
          itemText = _this.text();

        _this.parents( '.star-wrap' ).append( `<span class="star-score--new">${ itemText }.0</span>` );
      } );

      if ( reviewItem.length > 3 ) {
        reviewList.append( showMoreReviewsButton );
        const showButton = $( '.review-more' );

        showButton.on( 'click', function ( e ) {
          e.preventDefault();
          showButton.toggleClass( 'active' );

          if ( showButton.hasClass( 'active' ) ) {
            reviewItem.fadeIn( '200' );
            showButton.text( buttonTextLess );
          } else {
            reviewItem.each( function ( i, item ) {
              let _this = $( item );
              if ( i > 2 ) {
                _this.fadeOut( '200' );
                showButton.text( buttonTextMore );
              }
            } );
          }
        } );
      }

      $('.category-back').on('click', function (e) {
        e.preventDefault();
        window.history.back();
      });
    }

    const singleProduct = $('.single-product');

    if ( singleProduct.length > 0 ) __init()
    else return;

})(jQuery);
